<template>
  <div id="Example">
    <div>
      <b-button
        @click="downloadPdf"
        size="sm"
        variant="info"
        :disabled="localBtnDisabled"
        style="float: right;"
        ><i class="fa fa-angle-double-down" aria-hidden="true"></i>
        {{ localBtnText }}
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/services/api";
import cancelOrderReportMixin from "@/mixins/cancel-order-report-mixin.js";
import generateAttendanceReportPdfMixin from "@/mixins/generate-attendance-report-pdf-mixin.js";

export default {
  mixins: [cancelOrderReportMixin, generateAttendanceReportPdfMixin],
  name: "example",
  components: {},
  props: {
    selectedMonth: { type: String, default: null },
    start: { type: String, default: null },
    end: { type: String, default: null },
    studentFirstName: { type: String, default: null },
    studentLastName: { type: String, default: null },
    studentEmail: { type: String, default: null },
    invoiceNumber: { type: String, default: null },
    btnDisabled: { type: Boolean, default: true },
    text: { type: String, default: "ดาวน์โหลดรายงานรายการที่ยกเลิก" },
    status: { type: String, default: "all" },
  },
  data() {
    const currentDate = new Date();
    const companyNameMap = {
      1000001: "สถาบันกวดวิชาวรรณสรณ์",
      1000002: "สถาบันกวดวิชาแอพพลายด์ฟิสิกส์",
      1000003: "สถาบันกวดวิชาชีววิทยา ไบโอบีม เซ็นเตอร์",
    };
    const subjectNameMap = {
      1000001: "เคมี",
      1000002: "ฟิสิกส์",
      1000003: "ชีววิทยา",
    };
    const comId = this.$store.state.Company.companyInfo.id;
    return {
      comId,
      moment: moment,
      userInfo: JSON.parse(localStorage.getItem("user")),
      comName: companyNameMap[comId] || "",
      subjectName: subjectNameMap[comId] || "",
      data: {},
      cancelInfo: {},
      courseOnlineType: "",
      localBtnDisabled: this.btnDisabled,
      localBtnText: this.text,
      chartWidth: 360,
      chartHeight: 200,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        // orientation: "p",
        orientation: "l",
        format: "a4",
        unit: "px",
        lineHeight: 2,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 12,
          small: 10,
          chartHeader: 18,
          extraSmall: 8,
        },
        margin: {
          t: 40,
          b: 40,
          l: 40,
          r: 40,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endNormal: 12,
        endRow: 18,
        endLegend: 32,
      },

      //pdf all course
      pdfAllCourseOption: {
        orientation: "l",
        format: "a4",
        unit: "px",
        lineHeight: 2,
        putOnlyUsedFonts: true,
      },
      pdfAllCourseConfig: {
        typo: {
          header: 14,
          large: 16,
          normal: 9,
          small: 7,
          chartHeader: 18,
        },
        margin: {
          t: 72,
          b: 40,
          l: 40,
          r: 40,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endNormal: 11,
        endRow: 18,
        endTable: 16,
        endRowHeader: 27,
        endLegend: 32,
      },
      allCourseChartWidth: 470,
      allCourseChartHeight: 300,
    };
  },
  watch: {
    start(startMonth) {
      this.start = startMonth;
    },
    end(endMonth) {
      this.end = endMonth;
    },
    btnDisabled(newbtnDisabled) {
      this.localBtnDisabled = newbtnDisabled;
    },
    text(newText) {
      this.localBtnText = newText;
    },
  },
  methods: {
    async getCancelOrderData() {
      await api
        .get(`/v1/order-cancel-info?selectedMonth=${this.selectedMonth}&startDate=${this.start}&endDate=${this.end}&studentFirstName=${this.studentFirstName}&studentLastName=${this.studentLastName}&studentEmail=${this.studentEmail}&invoiceNumber=${this.invoiceNumber}`)
        .then(({ data }) => {
          this.cancelInfo = data;
        })
        .catch(() => {});
    },
    async downloadPdf() {
      await this.getCancelOrderData();
      await this.generatePdf();
    },
  },
};
</script>

<style></style>
